module.exports = __webpack_public_path__ + "static/media/AfterEffectsIcon.df62137a.svg";